import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: `${theme.spacing.spacing2} ${theme.spacing.spacing10}`,
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
  },
  submittingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.spacing10,
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    zIndex: theme.zIndex.modal,
  },
  helperText: {
    fontSize: theme.typography.size.md,
    textAlign: "center",
    marginBottom: theme.spacing.spacing5,
    color: theme.palette.text.primary,
    lineHeight: theme.typography.lineHeight.sm,
    padding: `0 ${theme.spacing.spacing5}`,
  },
  optionsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: theme.spacing.spacing15,
    marginBottom: theme.spacing.spacing5,
    alignItems: "stretch",
    padding: `0 ${theme.spacing.spacing5}`,
    flexWrap: "nowrap",
    width: "100%",
  },
  optionCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.spacing5} `,
    borderRadius: theme.borders.borderRadius.lg,
    border: `1px solid ${theme.palette.text.secondary}`,
    backgroundColor: theme.palette.transparent.main,
    cursor: "pointer",
    transition: "all 0.3s ease",
    flex: 1,
    maxWidth: "150px",
    justifyContent: "space-between",
    font: "inherit",
    color: "inherit",
    textAlign: "center",
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },
  optionCardSelected: {
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.boxShadows.lg,
  },
  optionLinesText: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    textAlign: "center",
  },
  optionImage: {
    marginBottom: theme.spacing.spacing10,
    marginTop: theme.spacing.spacing10,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  optionLabel: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    textAlign: "center",
    // marginTop: theme.spacing.spacing5,
  },
  buttonsSection: {
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: theme.width.full,
    paddingTop: theme.spacing.spacing5,
    paddingBottom: theme.spacing.spacing2,
    flexShrink: 0,
  },
  link: {
    marginBottom: theme.spacing.spacing5,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.sm,
    color: theme.palette.primary.main,
    cursor: "pointer",
    textDecoration: "none",
    border: "none",
    background: "none",
    padding: 0,
    fontFamily: "inherit",
    "&:hover:not(:disabled)": {
      textDecoration: "underline",
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.5,
    },
  },
});

